var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chip-item"},[_c('div',{staticClass:"chip-item-name",attrs:{"data-testid":"chip"}},[_vm._v(" "+_vm._s(_vm.chip)+" ")]),_c('span',{staticClass:"chip-item-close",on:{"click":_vm.removeChip}})])
}
var staticRenderFns = []

export { render, staticRenderFns }